import ISPyB from '../config/config.js';
import _ from 'lodash';

export function getAuthentication(server, site) {      
    return server + '/authenticate?site=' + site;
}

export function getSessions(user) {    
    return user.server + '/:token/session/list'.replace(':token', user.token);
}

export function getSessionsByProposal(user, proposal) {    
    return user.server + '/:token/proposal/:proposal/session/list'.replace(':token', user.token).replace(":proposal", proposal);
}

export function getProposals(user) {    
    return user.server + '/:token/proposal/list'.replace(':token', user.token);
}

export function getSessionsByDate(user, startDate, endDate) {
    return user.server + '/:token/proposal/session/date/:startDate/:endDate/list'
        .replace(':token', user.token)
        .replace(':startDate', startDate)
        .replace(':endDate', endDate);
}
/********************
 * SAXS
 ********************/
export function getSaxsExperimentsBySessionId(token, proposal, sessionId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/experiment/session/:sessionId/list'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':sessionId', sessionId);
}

export function getSaxsExperimentByExperimentId(token, proposal, experimentId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/experiment/:experimentId/get'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':experimentId', experimentId);
}

/** Get extended subtractions associated to a given experiment. 'Extended' indicates that subtraction entoty is enriched by associated entities */
export function getSaxsExtendedSubtractionsByExperimentId(token, proposal, experimentId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/datacollection/experiment/:experimentId/list'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':experimentId', experimentId);
}

export function getSaxsScatteringPlot(token, proposal, subtractionId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/image/scattering'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':subtractionId', subtractionId);
}

export function getSaxsKratkyPlot(token, proposal, subtractionId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/image/kratky'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':subtractionId', subtractionId);
}

export function getSaxsDensityPlot(token, proposal, subtractionId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/image/density'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':subtractionId', subtractionId);
}

export function getSaxsGuinierPlot(token, proposal, subtractionId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/image/guinier'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':subtractionId', subtractionId);
}
//get datacollections
export function getSaxsDataCollectionsAsBeanByDataCollectionIds(token, proposal, dataCollectionIds) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/datacollection/dataCollectionId/:dataCollectionIds/bean'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionIds', dataCollectionIds);
}

//END get dataCollections

// subtractions related
export function getSubtractionsAsListByDataCollectionIds(token, proposal, dataCollectionIds) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/datacollection/:dataCollectionId/list'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionId', dataCollectionIds);
}

export function getSaxsSubtractionAsListBySubtractionId(token, proposal, subtractionId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/list'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':subtractionId', subtractionId);
}

// frames related
export function getSaxsFrameListForSampleAndBufferByDataCollectionId(token, proposal, dataCollectionId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/datacollection/dataCollectionId/:dataCollectionId/bean'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionId', dataCollectionId);
}

export function getSaxsHPLCFrame(token, proposal, experimentId, frameId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/experiment/:experimentId/hplc/frame/:frameId/get?operation=log'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':experimentId', experimentId)
        .replace(':frameId', frameId);
};

export function downloadFramesByAverageIdList(token, proposal, mergeId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/frame/:mergeId/zip'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':mergeId', mergeId);
}

/**
 * URL to get contiguous frames for an HPLC experiment
 * @param {*} token ispyb token
 * @param {*} proposal proposal name
 * @param {*} experimentId experiment identifier
 * @param {*} startFrameId start frame identifier
 * @param {*} endFrameId end frame identifier
 */
export function getDownloadHDF5FramesURL(token, proposal, experimentId, startFrameId, endFrameId) {    
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/experiment/:experimentId/hplc/frame/:startFrameId/:endFrameId/zip'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':experimentId', experimentId)
        .replace(':startFrameId', startFrameId)
        .replace(':endFrameId', endFrameId);
}

// merge related
export function getSaxsMergedFrameByMergeId(token, proposal, commaSeparatedmergeIds) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/frame/average/:commaSeparatedmergeIds/bean'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':commaSeparatedmergeIds', commaSeparatedmergeIds);
}

/** Get merge entities associated to a given datacollection. 'Extended' indicates that additional properties from associated entities are provided. */
export function getExtendedMergesByMergeIds(token, proposal, mergeIds) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/frame/average/:mergeIds/bean'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':mergeIds', mergeIds);
}

// plotting data related
export function getPlottingDataByFrame(token, frameId, averageId, subtractedId, sampleAverageId, bufferAverageId, models, operation) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/frame/datplot?frame=:frameId&average=:averageId&subtracted=:subtractedId&sampleaverage=:sampleAverageId&bufferaverage=:bufferAverageId&models=:models&operation=:operation'
        .replace(':token', token)
        .replace(':proposal', 'undefined')
        .replace(':frameId', frameId || '')
        .replace(':averageId', averageId || '')
        .replace(':subtractedId', subtractedId || '')
        .replace(':sampleAverageId', sampleAverageId || '')
        .replace(':bufferAverageId', bufferAverageId || '')
        .replace(':models', models || '')
        .replace(':operation', operation || '')
        .replace(':proposal', 'undefined')
}

export function getFirContentByModelId(token, proposal, subtractionId, modelId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/model/:modelId/fir/content'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':subtractionId', subtractionId)
        .replace(':modelId', modelId)
}

export function getFitContentByModelId(token, proposal, subtractionId, modelId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/model/:modelId/fit/content'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':subtractionId', subtractionId)
        .replace(':modelId', modelId)
}

// HPLC related calls
export function getHPLCOverviewByExperimentId(token, proposal, experimentId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/experiment/:experimentId/hplc/overview'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':experimentId', experimentId)
}

// Others
export function getNSDURLbyModelListId(token, subtractionId, modelListId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/modellist/:modelListId/nsd'
        .replace(':token', token)
        .replace(':proposal', 'undefined')
        .replace(':subtractionId', subtractionId)
        .replace(':modelListId', modelListId);
}

export function getChi2RgURLbyModelListId(token, subtractionId, modelListId) {
    return ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/modellist/:modelListId/chi2rg'
        .replace(':token', token)
        .replace(':proposal', 'undefined')
        .replace(':subtractionId', subtractionId)
        .replace(':modelListId', modelListId);
}

export function getPDBByModelId(token, proposal, subtractionId, modelId) {
    return ISPyB.server + '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/model/:modelId/pdb'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':subtractionId', subtractionId)
        .replace(':modelId', modelId)
}

export function getFirByModelId(token, proposal, subtractionId, modelId) {
    return  ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/model/:modelId/fir'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':subtractionId', subtractionId)
        .replace(':modelId', modelId)
}

export function getLogByModelId(token, proposal, subtractionId, modelId) {
    return  ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/model/:modelId/log'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':subtractionId', subtractionId)
        .replace(':modelId', modelId)
}

export function getPDB(token, proposal) {
    return  ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/modeling/pdb/get'
        .replace(':token', token)
        .replace(':proposal', proposal)
}

export function getZip(token, proposal, subtractionId) {
    return  ISPyB.sites[0].server + '/:token/proposal/:proposal/saxs/subtraction/:subtractionId/zip'
        .replace(':token', token)
        .replace(':proposal', proposal)
        .replace(':subtractionId', subtractionId)
};





/********************
 * EM
 ********************/
/*export function getEmDataColletionGroupBySessionId(user, proposal, sessionId) {
    return user.server + '/:token/proposal/session/:sessionId/list'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':sessionId', sessionId);
}*/

export function getEmDataColletionBySessionId(user, proposal, sessionId) {
    return user.server + '/:token/proposal/:proposal/em/datacollection/session/:sessionId/list'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':sessionId', sessionId);
}

export function getEmMoviesByDataCollectionId(user, proposal, dataCollectionId) {
    return user.server + '/:token/proposal/:proposal/em/datacollection/:dataCollectionId/movie/all'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionId', dataCollectionId);
}

export function getMovieThumbnail(user, proposal, dataCollectionId, movieId) {
    return user.server + '/:token/proposal/:proposal/em/datacollection/:dataCollectionId/movie/:movieId/thumbnail'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionId', dataCollectionId)
        .replace(':movieId', movieId);
}

export function getMotionCorrectionDrift(user, proposal, dataCollectionId, movieId) {
    return user.server + '/:token/proposal/:proposal/em/datacollection/:dataCollectionId/movie/:movieId/motioncorrection/drift'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionId', dataCollectionId)
        .replace(':movieId', movieId);
}

export function getMotionCorrectionThumbnail(user, proposal, dataCollectionId, movieId) {
    return user.server + '/:token/proposal/:proposal/em/datacollection/:dataCollectionId/movie/:movieId/motioncorrection/thumbnail'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionId', dataCollectionId)
        .replace(':movieId', movieId);
}

export function getCTFThumbnail(user, proposal, dataCollectionId, movieId) {
    return user.server + '/:token/proposal/:proposal/em/datacollection/:dataCollectionId/movie/:movieId/ctf/thumbnail'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionId', dataCollectionId)
        .replace(':movieId', movieId);
}

export function getEmStats(user, proposal, sessionId) {
    return user.server + '/:token/proposal/:proposal/em/session/:sessionId/stats'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':sessionId', sessionId);
}

/********************
 * MX
 ********************/
export function getMXDataColletionGroupBySessionId(user, proposal, sessionId) {
    return user.server + '/:token/proposal/:proposal/mx/datacollection/session/:sessionId/list'
        .replace(':token', user.token)
        .replace(':proposal', proposal)
        .replace(':sessionId', sessionId);
}

export function getDiffrationThumbnail(user, proposal, imageId) {
    return user.server + '/:token/proposal/:proposal/mx/image/:imageId/thumbnail'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':imageId', imageId);
}

export function getDozorPlot(user, proposal, dataCollectionId) {
    return user.server + '/:token/proposal/:proposal/mx/datacollection/:dataCollectionId/qualityindicatorplot'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionId', dataCollectionId);
}

export function getCrystalImage(user, proposal, dataCollectionId, imageIndex) {
    return user.server + '/:token/proposal/:proposal/mx/datacollection/:dataCollectionId/crystalsnaphot/:imageIndex/get'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionId', dataCollectionId)
        .replace(':imageIndex', imageIndex);
}

export function getDataCollectionByGroupId(user, proposal, dataCollectionGroupId) {
    return user.server + '/:token/proposal/:proposal/mx/datacollection/datacollectiongroupid/:dataCollectionGroupId/list'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionGroupId', dataCollectionGroupId);
}

export function getAutoprocResultsByDataCollectionId(user, proposal, dataCollectionId) {
    return user.server + '/:token/proposal/:proposal/mx/autoprocintegration/datacollection/:dataCollectionId/view'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionId', dataCollectionId);
}


export function getDownloadAutoprocessingFiles(user, proposal, autoprocProgramId, forcedFileName) {    
    return user.server + '/:token/proposal/:proposal/mx/autoprocintegration/attachment/autoprocprogramid/:autoprocProgramId/download?forceFilename=:forcedFileName'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':autoprocProgramId', autoprocProgramId)
        .replace(':forcedFileName', forcedFileName);
}

export function getWorkflowImage(user, proposal, stepId) {
    return user.server + '/:token/proposal/:proposal/mx/workflow/step/:stepId/image'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':stepId', stepId);
}

export function saveDataCollectionComments(user, proposal, dataCollectionGroupId) {
    return user.server + '/:token/proposal/:proposal/mx/datacollectiongroup/:dataCollectionGroupId/comments/save'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionGroupId', dataCollectionGroupId);
}

export function getWorflowStepList(user, proposal, workflowStepListIds) {
    return user.server + '/:token/proposal/:proposal/mx/workflow/step/:workflowStepListIds/list'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':workflowStepListIds', workflowStepListIds);
}

export function getWorflowStepResultById(user, proposal, workflowStepId) {
    return user.server + '/:token/proposal/:proposal/mx/workflow/step/:workflowStepId/result'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':workflowStepId', workflowStepId);
}

export function getPhasingByDataCollectionGroupId(user, proposal, dataCollectionGroupId) {
    return user.server + '/:token/proposal/:proposal/mx/phasing/datacollectiongroupid/:dataCollectionGroupId/list'
        .replace(':token',user.token)
        .replace(':proposal', proposal)
        .replace(':dataCollectionGroupId', dataCollectionGroupId);
}

export function downloadPhasingFilesByPhasingAttachmentId(user, proposal, phasingAttachmentId){
	return user.server + '/:token/proposal/:proposal/mx/phasing/phasingprogramattachmentid/:phasingAttachmentId/download'
    .replace(':token',user.token)
    .replace(':proposal', proposal)
    .replace(':phasingAttachmentId', phasingAttachmentId);
};

export function getCSVPhasingFilesByPhasingAttachmentIdURL(user, proposal, phasingAttachmentId){
	return user.server + '/:token/proposal/:proposal/mx/phasing/phasingprogramattachmentid/:phasingAttachmentId/csv'
    .replace(':token',user.token)
    .replace(':proposal', proposal)
    .replace(':phasingAttachmentId', phasingAttachmentId);
};

export function getDownloadFilesByPhasingStepIdURL(user, proposal, phasingStepId){
	return user.server + '/:token/proposal/:proposal/mx/phasing/phasingstepid/:phasingStepId/download'
    .replace(':token',user.token)
    .replace(':proposal', proposal)
    .replace(':phasingStepId', phasingStepId);
};

export function getPhasingFilesByPhasingProgramAttachmentIdAsImage(user, proposal, phasingAttachmentId){
	return user.server + '/:token/proposal/:proposal/mx/phasing/phasingprogramattachmentid/:phasingAttachmentId/image'
    .replace(':token',user.token)
    .replace(':proposal', proposal)
    .replace(':phasingAttachmentId', phasingAttachmentId);
};






// WEBPACK FOOTER //
// ./src/api/ispyb.js